import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaSwiperComponent } from './media-swiper.component';
import { MotesMediaModule } from '../motes-media/motes-media.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MediaSwiperRoutingModule } from './media-swiper-routing.module';
import { SwiperModule } from '@motes-sdk/directives';

@NgModule({
    declarations: [
        MediaSwiperComponent
    ],
    imports: [
        CommonModule,
        SwiperModule,
        MotesMediaModule,
        SvgIconModule,
        MediaSwiperRoutingModule
    ],
    exports: [
        MediaSwiperComponent
    ]
})
export class MediaSwiperModule { }
